import React from "react";
console.log(React);
export function useInterval(delay, effect) {
    var savedCallback = React.useRef();
    React.useEffect(function () {
        savedCallback.current = effect;
    }, [effect]);
    React.useEffect(function () {
        function tick() {
            if (savedCallback.current) {
                savedCallback.current();
            }
        }
        var id = setInterval(tick, delay);
        return function () { return clearInterval(id); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
;
